import React from "react";
import { Link } from "react-router-dom";
import EntityPage from "@/components/EntityPage";
import Pill from "@/components/Pill";
import { useRefData } from "@/context/RefDataContext";

export default function TasksPage() {
  const ref = useRefData();

  const lookup = (list, id) => list?.find((x) => x.value === id)?.label || "—";

  const columns = [
    {
      key: "code",
      label: "Task ID",
      render: (t) => (
        <Link
          to={`/tasks/${t.id}`}
          className="font-mono text-xs text-sky-400 hover:underline"
          data-testid={`tasks-code-${t.id}`}
        >
          {t.code}
        </Link>
      ),
    },
    {
      key: "subject",
      label: "Subject",
      render: (t) => (
        <Link
          to={`/tasks/${t.id}`}
          className="text-white hover:text-sky-300 transition-colors"
          data-testid={`tasks-subject-${t.id}`}
        >
          {t.subject}
        </Link>
      ),
    },
    { key: "project_id", label: "CDARK", render: (t) => <span className="text-zinc-400 text-xs">{lookup(ref.projects, t.project_id)}</span> },
    { key: "team_id", label: "Team", render: (t) => <span className="text-zinc-400 text-xs">{lookup(ref.teams, t.team_id)}</span> },
    { key: "priority", label: "Priority", render: (t) => <Pill kind="priority" value={t.priority} /> },
    { key: "status", label: "Status", render: (t) => <Pill kind="status" value={t.status} /> },
    { key: "due_date", label: "Due", render: (t) => <span className="text-zinc-400 text-xs">{t.due_date || "—"}</span> },
  ];

  const fields = [
    { key: "subject", label: "Subject", required: true, full: true },
    { key: "project_id", label: "CDARK (optional)", type: "select", optionsRef: "projects" },
    { key: "biz_project_id", label: "Project (optional)", type: "select", optionsRef: "biz_projects_open" },
    { key: "team_id", label: "Team", type: "select", optionsRef: "teams" },
    { key: "assigned_user_id", label: "Assigned User", type: "select", optionsRef: "users" },
    { key: "priority", label: "Priority", type: "select", optionsRef: "priorities" },
    { key: "status", label: "Status", type: "select", optionsRef: "statuses" },
    { key: "asset_id", label: "Related Asset", type: "select", optionsRef: "assets", filterBy: "project_id" },
    { key: "service_id", label: "Related Service", type: "select", optionsRef: "services", filterBy: "project_id" },
    { key: "due_date", label: "Due Date", type: "date" },
    { key: "details", label: "Task Details", type: "textarea", full: true },
    { key: "files", label: "Attachments", type: "files", full: true },
  ];

  const initial = {
    subject: "",
    project_id: "",
    biz_project_id: "",
    team_id: "",
    assigned_user_id: "",
    priority: "Medium",
    status: "Open",
    asset_id: "",
    service_id: "",
    due_date: "",
    details: "",
    files: [],
  };

  return (
    <EntityPage
      title="Tasks"
      subtitle="Work items tagged to a CDARK or a Project."
      testidPrefix="tasks"
      endpoint="/tasks"
      columns={columns}
      fields={fields}
      initialForm={initial}
      referenceData={ref}
    />
  );
}
